import React from "react";
import { Check } from "lucide-react";
import { ICONS } from "../../utils/icons";
import { DESIGN_TOKENS } from "../../constants/designTokens";
import { getDepartmentClassLabel } from "../../utils/studentDisplay";
import {
  ATTENDANCE_DAILY_CARD_AFFILIATION_BADGE_CLASS,
  ATTENDANCE_DAILY_CARD_BODY_CLASS,
  ATTENDANCE_DAILY_CARD_GRID_CLASS,
  ATTENDANCE_DAILY_CARD_STATUS_GROUP_CLASS,
  getAttendanceDailyCardCheckClass,
  getAttendanceDailyCardClass,
  getAttendanceDailyCardStatusButtonClass,
  getAttendanceDailyCardStatusDotClass,
} from "./attendanceMobileStyles";

export default function AttendanceDailyCardGrid({
  GlassCard,
  dailyAttendance,
  filteredStudents,
  handleSelectRow,
  handleStatusChange,
  selectedIds,
  targetGroup,
  selectedDepartment,
  handleMarkDragStart,
  handleSelectDragStart,
  handleDragOver,
  isDragging,
  dragStatus,
}) {
  const brand = DESIGN_TOKENS.brand;

  return (
    <div className={ATTENDANCE_DAILY_CARD_GRID_CLASS}>
      {filteredStudents.map((s) => {
        const status = dailyAttendance[s.id];
        const isSelected = selectedIds.includes(s.id);
        const showDepartment = targetGroup !== "students" || selectedDepartment === "All";
        const affiliationLabel = getDepartmentClassLabel(s, { showDepartment });

        return (
          <GlassCard
            key={s.id}
            data-id={s.id}
            onMouseDown={(e) => {
              // Only start selection drag if clicking the card background, not the status buttons
              if (e.target.closest('button')) return;
              e.stopPropagation();
              handleSelectDragStart?.(s.id, e);
            }}
            onMouseEnter={() => handleDragOver?.(s.id)}
            className={`${getAttendanceDailyCardClass({ status, isSelected, brand })} selection-item ${s.faithState === "장기결석" && !isSelected ? "opacity-50 grayscale-[0.5]" : ""}`}
          >
            <div className={`${getAttendanceDailyCardCheckClass(isSelected, brand)} pointer-events-none`}>
              {isSelected && <Check size={12} className="text-white" />}
            </div>

            <div className={ATTENDANCE_DAILY_CARD_BODY_CLASS}>
              <div className="relative mb-3 pointer-events-none">
                {s.photoUrl ? (
                  <img src={s.photoUrl} alt={s.name} className="w-14 h-14 rounded-[20px] object-cover border-2 border-white shadow-md" />
                ) : (
                  <div className="w-14 h-14 rounded-[20px] border-2 border-white flex items-center justify-center shadow-md bg-white overflow-hidden">
                    <img src={targetGroup === "teachers" ? (s.gender === "여" ? ICONS.teacher_female : ICONS.teacher_male) : (s.gender === "남" ? "/images/boy_3d_light.png" : (s.gender === "여" ? "/images/girl_3d_light.png" : "/images/boy_3d_light.png"))} alt="avatar" className="w-full h-full object-cover transform scale-110" />
                  </div>
                )}
                {s.faithState === "초신자" && (
                  <div className="absolute -bottom-1 -right-1 bg-yellow-400 text-white text-[8px] font-black px-1.5 py-0.5 rounded-full shadow-sm border-2 border-white z-10 animate-pulse">
                    NEW
                  </div>
                )}
                {s.faithState === "장기결석" && (
                  <div className="absolute -bottom-1 -right-1 bg-gray-500 text-white text-[7px] font-black px-1.5 py-0.5 rounded-full shadow-sm border border-white z-10">
                    LONG
                  </div>
                )}
              </div>

              <h4 className="font-black text-lg text-gray-800 mb-1 leading-tight pointer-events-none">{s.name}</h4>
              <div className="flex items-center gap-1 justify-center mb-4 pointer-events-none">
                {affiliationLabel && (
                  <span className={ATTENDANCE_DAILY_CARD_AFFILIATION_BADGE_CLASS}>
                    {affiliationLabel}
                  </span>
                )}
              </div>

              <div className={ATTENDANCE_DAILY_CARD_STATUS_GROUP_CLASS}>
                <button
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); handleMarkDragStart?.("present", s.id, e); }}
                  onClick={(e) => { e.stopPropagation(); handleStatusChange(s.id, "present"); }}
                  className={getAttendanceDailyCardStatusButtonClass(status, "present")}
                >
                  <div className={getAttendanceDailyCardStatusDotClass(status, "present")}></div>
                  출석
                </button>
                <button
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); handleMarkDragStart?.("late", s.id, e); }}
                  onClick={(e) => { e.stopPropagation(); handleStatusChange(s.id, "late"); }}
                  className={getAttendanceDailyCardStatusButtonClass(status, "late")}
                >
                  <div className={getAttendanceDailyCardStatusDotClass(status, "late")}></div>
                  지각
                </button>
                <button
                  onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); handleMarkDragStart?.("absent", s.id, e); }}
                  onClick={(e) => { e.stopPropagation(); handleStatusChange(s.id, "absent"); }}
                  className={getAttendanceDailyCardStatusButtonClass(status, "absent")}
                >
                  <div className={getAttendanceDailyCardStatusDotClass(status, "absent")}></div>
                  결석
                </button>
              </div>
            </div>
          </GlassCard>
        );
      })}
    </div>
  );
}
